import { Component, OnInit } from '@angular/core'
import { StadiumCamerasService } from 'app/services/stadium-cameras.service'
import { Stadium } from 'app/models/stadium'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { Competition } from 'app/models/competition'
import { CompetitionService } from '../../services/competition.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-stadium',
  templateUrl: './stadium.component.html',
  styleUrls: ['./stadium.component.scss'],
  providers: [StadiumCamerasService]
})
export class StadiumComponent implements OnInit {
  public stadiumData
  stadium: Stadium
  competition: Competition
  fullScreenMode: boolean
  private fullscreenObserver = new BehaviorSubject<boolean>(false)
  private subscription: Subscription

  constructor(
    private stadiumCamerasService: StadiumCamerasService,
    private competitionService: CompetitionService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getAll()
    this.competition = this.competitionService.getCompetitionSelected()
    this.subscription = this.fullscreenObserver
      .subscribe((value) => {
        this.fullScreenMode = value
      })
    if (this.competition.hasOwnProperty('hide_stadium') && this.competition.hide_stadium === true) {
      this.router.navigate(['competition'])
    }
  }

  getAll() {
    this.stadiumCamerasService
      .getAll()
      .subscribe(res => this.stadium = res)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/views/stadium/stadium.component.ts